import { firestore } from "../_firebase";
import { forEach } from "lodash";
import Collection from "../_collections";
const addMaritalStatus = () => {
  const values = [
    {
      id: "neverMarried",
      data: {
        label: "Never Married",
        value: "neverMarried",
        description: "Never Married"
      }
    },
    {
      id: "widower",
      data: {
        label: "Widower",
        value: "widower",
        description: "Widower"
      }
    },
    {
      id: "divorced",
      data: {
        label: "Divorced",
        value: "divorced",
        description: "Divorced"
      }
    },
    {
      id: "awaitingDivorce",
      data: {
        label: "Awaiting Divorce",
        value: "awaitingDivorce",
        description: "Awaiting Divorce"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.MARITAL_STATUS)
      .doc(item.id)
      .set(item.data);
  });
};
const addMotherTongue = () => {
  const values = [
    {
      id: "english",
      data: {
        label: "English",
        value: "english",
        description: "English"
      }
    },
    {
      id: "hindi",
      data: {
        label: "Hindi",
        value: "hindi",
        description: "Hindi"
      }
    },
    {
      id: "bengali",
      data: {
        label: "Bengali",
        value: "bengali",
        description: "Bengali"
      }
    },
    {
      id: "telugu",
      data: {
        label: "Telugu",
        value: "telugu",
        description: "Telugu"
      }
    },
    {
      id: "marathi",
      data: {
        label: "Marathi",
        value: "marathi",
        description: "Marathi"
      }
    },
    {
      id: "tamil",
      data: {
        label: "Tamil",
        value: "tamil",
        description: "Tamil"
      }
    },
    {
      id: "urdu",
      data: {
        label: "Urdu",
        value: "urdu",
        description: "Urdu"
      }
    },
    {
      id: "gujarati",
      data: {
        label: "Gujarati",
        value: "gujarati",
        description: "Gujarati"
      }
    },
    {
      id: "kannada",
      data: {
        label: "Kannada",
        value: "kannada",
        description: "Kannada"
      }
    },
    {
      id: "malayalam",
      data: {
        label: "Malayalam",
        value: "malayalam",
        description: "Malayalam"
      }
    },
    {
      id: "odia",
      data: {
        label: "Odia",
        value: "odia",
        description: "Odia"
      }
    },
    {
      id: "pubjabi",
      data: {
        label: "Pubjabi",
        value: "pubjabi",
        description: "Pubjabi"
      }
    },
    {
      id: "assamese",
      data: {
        label: "Assamese",
        value: "assamese",
        description: "Assamese"
      }
    },
    {
      id: "maithili",
      data: {
        label: "Maithili",
        value: "maithili",
        description: "Maithili"
      }
    },
    {
      id: "santali",
      data: {
        label: "Santali",
        value: "santali",
        description: "Santali"
      }
    },
    {
      id: "kashmiri",
      data: {
        label: "Kashmiri",
        value: "kashmiri",
        description: "Kashmiri"
      }
    },
    {
      id: "nepali",
      data: {
        label: "Nepali",
        value: "nepali",
        description: "Nepali"
      }
    },
    {
      id: "sindhi",
      data: {
        label: "Sindhi",
        value: "sindhi",
        description: "Sindhi"
      }
    },
    {
      id: "konkani",
      data: {
        label: "Konkani",
        value: "konkani",
        description: "Konkani"
      }
    },
    {
      id: "dogri",
      data: {
        label: "Dogri",
        value: "dogri",
        description: "Dogri"
      }
    },
    {
      id: "meitei",
      data: {
        label: "Meitei",
        value: "meitei",
        description: "Meitei"
      }
    },
    {
      id: "bodo",
      data: {
        label: "Bodo",
        value: "bodo",
        description: "Bodo"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.MOTHER_TONGUE)
      .doc(item.id)
      .set(item.data);
  });
};
const addComplexion = () => {
  const values = [
    {
      id: "veryFair",
      data: {
        label: "Very Fair",
        value: "veryFair",
        description: "Very Fair"
      }
    },
    {
      id: "fair",
      data: {
        label: "Fair",
        value: "fair",
        description: "Fair"
      }
    },
    {
      id: "wheatish",
      data: {
        label: "Wheatish",
        value: "wheatish",
        description: "Wheatish"
      }
    },
    {
      id: "dark",
      data: {
        label: "Dark",
        value: "dark",
        description: "Dark"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.COMPLEXION)
      .doc(item.id)
      .set(item.data);
  });
};
const addBodyType = () => {
  const values = [
    {
      id: "slim",
      data: {
        label: "Slim",
        value: "slim",
        description: "Slim"
      }
    },
    {
      id: "average",
      data: {
        label: "Average",
        value: "average",
        description: "Average"
      }
    },
    {
      id: "athletic",
      data: {
        label: "Athletic",
        value: "athletic",
        description: "Athletic"
      }
    },
    {
      id: "heavy",
      data: {
        label: "Heavy",
        value: "heavy",
        description: "Heavy"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.BODY_TYPE)
      .doc(item.id)
      .set(item.data);
  });
};
const addDiet = () => {
  const values = [
    {
      id: "vegetarian",
      data: {
        label: "Vegetarian",
        value: "vegetarian",
        description: "Vegetarian"
      }
    },
    {
      id: "nonVeg",
      data: {
        label: "Non Veg (Meat)",
        value: "nonVeg",
        description: "Non Veg (Meat)"
      }
    },
    {
      id: "vegan",
      data: {
        label: "Vegan",
        value: "vegan",
        description: "Vegan"
      }
    },
    {
      id: "eggetarian",
      data: {
        label: "Eggetarian",
        value: "eggetarian",
        description: "Eggetarian"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.DIET)
      .doc(item.id)
      .set(item.data);
  });
};
const addHabitTypes = () => {
  const values = [
    {
      id: "occasionally",
      data: {
        label: "Occasionally",
        value: "occasionally",
        description: "Occasionally"
      }
    },
    {
      id: "no",
      data: {
        label: "No",
        value: "no",
        description: "No"
      }
    },
    {
      id: "yes",
      data: {
        label: "Yes",
        value: "yes",
        description: "Yes"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.HABIT_TYPE)
      .doc(item.id)
      .set(item.data);
  });
};
const addJobType = () => {
  const values = [
    {
      id: "private",
      data: {
        label: "Private Company",
        value: "private",
        description: "Private Company"
      }
    },
    {
      id: "public",
      data: {
        label: "Government/Public Sector",
        value: "public",
        description: "Government/Public Sector"
      }
    },
    {
      id: "civil",
      data: {
        label: "Civil Services",
        value: "civil",
        description: "Civil Services"
      }
    },
    {
      id: "business",
      data: {
        label: "Business",
        value: "business",
        description: "Business"
      }
    },
    {
      id: "notWorking",
      data: {
        label: "Not Working",
        value: "notWorking",
        description: "Not Working"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.JOB_TYPE)
      .doc(item.id)
      .set(item.data);
  });
};
const addIncome = () => {
  const values = [
    {
      id: "lessThan1",
      data: {
        label: "Less Than 1 Lakh",
        value: "lessThan1",
        description: "Less Than 1 Lakh"
      }
    },
    {
      id: "1To3",
      data: {
        label: "1 Lakh to 3 Lakh",
        value: "1To3",
        description: "1 Lakh to 3 Lakh"
      }
    },
    {
      id: "3To5",
      data: {
        label: "3 Lakh to 5 Lakh",
        value: "3To5",
        description: "3 Lakh to 5 Lakh"
      }
    },
    {
      id: "5To10",
      data: {
        label: "5 Lakh to 10 Lakh",
        value: "5To10",
        description: "5 Lakh to 10 Lakh"
      }
    },
    {
      id: "10To50",
      data: {
        label: "10 Lakh to 50 Lakh",
        value: "10To50",
        description: "10 Lakh to 50 Lakh"
      }
    },
    {
      id: "greaterThan50",
      data: {
        label: "Greater Than 50 Lakh",
        value: "greaterThan50",
        description: "Greater Than 50 Lakh"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.INCOME)
      .doc(item.id)
      .set(item.data);
  });
};
const addEducation = () => {
  const values = [
    {
      id: "bTech",
      data: {
        label: "B.E/B.Tech",
        value: "bTech",
        description: "B.E/B.Tech"
      }
    },
    {
      id: "bPharm",
      data: {
        label: "B.Pharm",
        value: "bPharm",
        description: "B.Pharm"
      }
    },
    {
      id: "mTech",
      data: {
        label: "M.E/M.Tech",
        value: "mTech",
        description: "M.E/M.Tech"
      }
    },
    {
      id: "mPharm",
      data: {
        label: "M.Pharm",
        value: "mPharm",
        description: "M.Pharm"
      }
    },
    {
      id: "mse",
      data: {
        label: "M.S (Engineering)",
        value: "mse",
        description: "M.S (Engineering)"
      }
    },
    {
      id: "bca",
      data: {
        label: "BCA",
        value: "bca",
        description: "BCA"
      }
    },
    {
      id: "mca",
      data: {
        label: "MCA",
        value: "mca",
        description: "MCA"
      }
    },
    {
      id: "bcom",
      data: {
        label: "B.Com",
        value: "bcom",
        description: "B.Com"
      }
    },
    {
      id: "mcom",
      data: {
        label: "M.Com",
        value: "mcom",
        description: "M.Com"
      }
    },
    {
      id: "ca",
      data: {
        label: "CA",
        value: "ca",
        description: "CA"
      }
    },
    {
      id: "bba",
      data: {
        label: "BBA",
        value: "bba",
        description: "BBA"
      }
    },
    {
      id: "mba",
      data: {
        label: "MBA",
        value: "mba",
        description: "MBA"
      }
    },
    {
      id: "bams",
      data: {
        label: "BAMS",
        value: "bams",
        description: "BAMS"
      }
    },
    {
      id: "bds",
      data: {
        label: "BDS",
        value: "bds",
        description: "BDS"
      }
    },
    {
      id: "md",
      data: {
        label: "M.D",
        value: "md",
        description: "M.D"
      }
    },
    {
      id: "msm",
      data: {
        label: "M.S (Medicine)",
        value: "msm",
        description: "M.S (Medicine)"
      }
    },
    {
      id: "mds",
      data: {
        label: "MDS",
        value: "mds",
        description: "MDS"
      }
    },
    {
      id: "mbbs",
      data: {
        label: "MBBS",
        value: "mbbs",
        description: "MBBS"
      }
    },
    {
      id: "llb",
      data: {
        label: "LLB",
        value: "llb",
        description: "LLB"
      }
    },
    {
      id: "llm",
      data: {
        label: "LLM",
        value: "llm",
        description: "LLM"
      }
    },
    {
      id: "ba",
      data: {
        label: "B.A",
        value: "ba",
        description: "B.A"
      }
    },
    {
      id: "bed",
      data: {
        label: "B.Ed",
        value: "bed",
        description: "B.Ed"
      }
    },
    {
      id: "bsc",
      data: {
        label: "B.Sc",
        value: "bsc",
        description: "B.Sc"
      }
    },
    {
      id: "ma",
      data: {
        label: "M.A",
        value: "ma",
        description: "M.A"
      }
    },
    {
      id: "med",
      data: {
        label: "M.Ed",
        value: "med",
        description: "M.Ed"
      }
    },
    {
      id: "msc",
      data: {
        label: "M.Sc",
        value: "msc",
        description: "M.Sc"
      }
    },
    {
      id: "phd",
      data: {
        label: "Ph.D",
        value: "phd",
        description: "Ph.D"
      }
    },
    {
      id: "highSchool",
      data: {
        label: "High School",
        value: "highSchool",
        description: "High School"
      }
    },
    {
      id: "diploma",
      data: {
        label: "Diploma",
        value: "diploma",
        description: "Diploma"
      }
    },
    {
      id: "other",
      data: {
        label: "Other",
        value: "other",
        description: "Other"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.EDUCATION)
      .doc(item.id)
      .set(item.data);
  });
};
const addEmployedIn = () => {
  const values = [
    {
      id: "agriculture",
      data: {
        label: "Agriculture",
        value: "agriculture",
        description: "Agriculture"
      }
    },
    {
      id: "foodAndNatural",
      data: {
        label: "Food And Natural",
        value: "foodAndNatural",
        description: "Food And Natural"
      }
    },
    {
      id: "architecture",
      data: {
        label: "Architecture",
        value: "architecture",
        description: "Architecture"
      }
    },
    {
      id: "construction",
      data: {
        label: "Construction",
        value: "construction",
        description: "Construction"
      }
    },
    {
      id: "arts",
      data: {
        label: "Arts",
        value: "arts",
        description: "Arts"
      }
    },
    {
      id: "communications",
      data: {
        label: "Communications",
        value: "communications",
        description: "Communications"
      }
    },
    {
      id: "bma",
      data: {
        label: "Business Management and Administration",
        value: "bma",
        description: "Business Management and Administration"
      }
    },
    {
      id: "educationTraining",
      data: {
        label: "Education And Training",
        value: "educationTraining",
        description: "Education And Training"
      }
    },
    {
      id: "finance",
      data: {
        label: "Finance",
        value: "finance",
        description: "Finance"
      }
    },
    {
      id: "govt",
      data: {
        label: "Government And Public Administration",
        value: "govt",
        description: "Government And Public Administration"
      }
    },
    {
      id: "healthScience",
      data: {
        label: "Health Science",
        value: "healthScience",
        description: "Health Science"
      }
    },
    {
      id: "hospitality",
      data: {
        label: "Hospitality And Tourism",
        value: "hospitality",
        description: "Hospitality And Tourism"
      }
    },
    {
      id: "humanServices",
      data: {
        label: "Human Services",
        value: "humanServices",
        description: "Human Services"
      }
    },
    {
      id: "it",
      data: {
        label: "Information Technology",
        value: "it",
        description: "Information Technology"
      }
    },
    {
      id: "law",
      data: {
        label: "Law",
        value: "law",
        description: "Law"
      }
    },
    {
      id: "security",
      data: {
        label: "Corrections And Security",
        value: "security",
        description: "Corrections And Security"
      }
    },
    {
      id: "manufacturing",
      data: {
        label: "Manufacturing",
        value: "manufacturing",
        description: "Manufacturing"
      }
    },
    {
      id: "marketing",
      data: {
        label: "Marketing",
        value: "marketing",
        description: "Marketing"
      }
    },
    {
      id: "sales",
      data: {
        label: "Sales And Service",
        value: "sales",
        description: "Sales And Service"
      }
    },
    {
      id: "engineering",
      data: {
        label: "Engineering",
        value: "engineering",
        description: "Engineering"
      }
    },
    {
      id: "transportation",
      data: {
        label: "Transportation And Logistics",
        value: "transportation",
        description: "Transportation And Logistics"
      }
    },
    {
      id: "other",
      data: {
        label: "Other",
        value: "other",
        description: "Other"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.EMPLOYED_IN)
      .doc(item.id)
      .set(item.data);
  });
};

const addReligion = () => {
  const values = [
    {
      id: "hindu",
      data: {
        label: "Hindu",
        value: "hindu",
        description: "Hindu"
      }
    },
    {
      id: "muslim",
      data: {
        label: "Muslim",
        value: "muslim",
        description: "Muslim"
      }
    },
    {
      id: "christian",
      data: {
        label: "Christian",
        value: "christian",
        description: "Christian"
      }
    },
    {
      id: "sikh",
      data: {
        label: "Sikh",
        value: "sikh",
        description: "Sikh"
      }
    },
    {
      id: "buddhist",
      data: {
        label: "Buddhist",
        value: "buddhist",
        description: "Buddhist"
      }
    },
    {
      id: "jain",
      data: {
        label: "Jain",
        value: "jain",
        description: "Jain"
      }
    },
    {
      id: "noReligion",
      data: {
        label: "No Religion",
        value: "noReligion",
        description: "No Religion"
      }
    },
    {
      id: "other",
      data: {
        label: "Other",
        value: "other",
        description: "Other"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.RELIGION)
      .doc(item.id)
      .set(item.data);
  });
};
const addCommunity = () => {
  const religions = [
    {
      id: "hindu",
      community: [
        {
          id: "kokanastha",
          data: {
            label: "96K Kokanastha",
            value: "kokanastha",
            description: "96K Kokanastha"
          }
        },
        {
          id: "adiAndhra",
          data: {
            label: "Adi Andhra",
            value: "adiAndhra",
            description: "Adi Andhra"
          }
        },
        {
          id: "adiDravida",
          data: {
            label: "Adi Dravida",
            value: "adiDravida",
            description: "Adi Dravida"
          }
        },
        {
          id: "adiKarnataka",
          data: {
            label: "Adi Karnataka",
            value: "adiKarnataka",
            description: "Adi Karnataka"
          }
        },
        {
          id: "agarwal",
          data: {
            label: "Agarwal",
            value: "agarwal",
            description: "Agarwal"
          }
        },
        {
          id: "agnikulaKshatriya",
          data: {
            label: "Agnikula Kshatriya",
            value: "agnikulaKshatriya",
            description: "Agnikula Kshatriya"
          }
        },
        {
          id: "agri",
          data: {
            label: "Agri",
            value: "agri",
            description: "Agri"
          }
        },
        {
          id: "ahom",
          data: {
            label: "Ahom",
            value: "ahom",
            description: "Ahom"
          }
        },
        {
          id: "ambalavasi",
          data: {
            label: "Ambalavasi",
            value: "ambalavasi",
            description: "Ambalavasi"
          }
        },
        {
          id: "arekatica",
          data: {
            label: "Arekatica",
            value: "arekatica",
            description: "Arekatica"
          }
        },
        {
          id: "arora",
          data: {
            label: "Arora",
            value: "arora",
            description: "Arora"
          }
        },
        {
          id: "arunthathiyar",
          data: {
            label: "Arunthathiyar",
            value: "arunthathiyar",
            description: "Arunthathiyar"
          }
        },
        {
          id: "aryaVysya",
          data: {
            label: "AryaVysya",
            value: "aryaVysya",
            description: "AryaVysya"
          }
        },
        {
          id: "aryasamaj",
          data: {
            label: "Arya Samaj",
            value: "aryasamaj",
            description: "Arya Samaj"
          }
        },
        {
          id: "ayyaraka",
          data: {
            label: "Ayyaraka",
            value: "ayyaraka",
            description: "Ayyaraka"
          }
        },
        {
          id: "badaga",
          data: {
            label: "Badaga",
            value: "badaga",
            description: "Badaga"
          }
        },
        {
          id: "baghel",
          data: {
            label: "Baghel",
            value: "baghel",
            description: "Baghel"
          }
        },
        {
          id: "bahi",
          data: {
            label: "Bahi",
            value: "bahi",
            description: "Bahi"
          }
        },
        {
          id: "baidya",
          data: {
            label: "Baidya",
            value: "baidya",
            description: "Baidya"
          }
        },
        {
          id: "baishnab",
          data: {
            label: "Baishnab",
            value: "baishnab",
            description: "Baishnab"
          }
        }
      ]
    },
    {
      id: "muslim",
      community: [
        {
          id: "other",
          data: {
            label: "Other",
            value: "other",
            description: "Other"
          }
        }
      ]
    },
    {
      id: "christian",
      community: [
        {
          id: "catholic",
          data: {
            label: "Catholic",
            value: "catholic",
            description: "Catholic"
          }
        },
        {
          id: "angloIndian",
          data: {
            label: "AngloIndian",
            value: "angloIndian",
            description: "AngloIndian"
          }
        }
      ]
    },
    {
      id: "sikh",
      community: [
        {
          id: "other",
          data: {
            label: "Other",
            value: "other",
            description: "Other"
          }
        }
      ]
    },
    {
      id: "buddhist",
      community: [
        {
          id: "other",
          data: {
            label: "Other",
            value: "other",
            description: "Other"
          }
        }
      ]
    },
    {
      id: "jain",
      community: [
        {
          id: "other",
          data: {
            label: "Other",
            value: "other",
            description: "Other"
          }
        }
      ]
    }
  ];
  forEach(religions, religion => {
    forEach(religion.community, item => {
      firestore
        .collection(Collection.RELIGION)
        .doc(religion.id)
        .collection(Collection.COMMUNITY)
        .doc(item.id)
        .set(item.data);
    });
  });
};
const addCaste = () => {
  const values = [
    {
      id: "same",
      data: {
        label: "Same Caste",
        value: "same",
        description: "Same Caste"
      }
    },
    {
      id: "any",
      data: {
        label: "Any Caste",
        value: "any",
        description: "Any Caste"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.CASTE)
      .doc(item.id)
      .set(item.data);
  });
};
const addHeight = () => {
  const values = [
    {
      id: "0",
      data: {
        label: "4ft",
        value: "0",
        description: "4ft"
      }
    },
    {
      id: "1",
      data: {
        label: "4ft 1in",
        value: "1",
        description: "4ft 1in"
      }
    },
    {
      id: "2",
      data: {
        label: "4ft 2in",
        value: "2",
        description: "4ft 2in"
      }
    },
    {
      id: "3",
      data: {
        label: "4ft 3in",
        value: "3",
        description: "4ft 3in"
      }
    },
    {
      id: "4",
      data: {
        label: "4ft 4in",
        value: "4",
        description: "4ft 4in"
      }
    },
    {
      id: "5",
      data: {
        label: "4ft 5in",
        value: "5",
        description: "4ft 5in"
      }
    },
    {
      id: "6",
      data: {
        label: "4ft 6in",
        value: "6",
        description: "4ft 6in"
      }
    },
    {
      id: "7",
      data: {
        label: "4ft 7in",
        value: "7",
        description: "4ft 7in"
      }
    },
    {
      id: "8",
      data: {
        label: "4ft 8in",
        value: "8",
        description: "4ft 8in"
      }
    },
    {
      id: "9",
      data: {
        label: "4ft 9in",
        value: "9",
        description: "4ft 9in"
      }
    },
    {
      id: "10",
      data: {
        label: "4ft 10in",
        value: "10",
        description: "4ft 10in"
      }
    },
    {
      id: "11",
      data: {
        label: "4ft 11in",
        value: "11",
        description: "4ft 11in"
      }
    },
    {
      id: "12",
      data: {
        label: "5ft",
        value: "12",
        description: "5ft"
      }
    },
    {
      id: "13",
      data: {
        label: "5ft 1in",
        value: "13",
        description: "5ft 1in"
      }
    },
    {
      id: "14",
      data: {
        label: "5ft 2in",
        value: "14",
        description: "5ft 2in"
      }
    },
    {
      id: "15",
      data: {
        label: "5ft 3in",
        value: "15",
        description: "5ft 3in"
      }
    },
    {
      id: "16",
      data: {
        label: "5ft 4in",
        value: "16",
        description: "5ft 4in"
      }
    },
    {
      id: "17",
      data: {
        label: "5ft 5in",
        value: "17",
        description: "5ft 5in"
      }
    },
    {
      id: "18",
      data: {
        label: "5ft 6in",
        value: "18",
        description: "5ft 6in"
      }
    },
    {
      id: "19",
      data: {
        label: "5ft 7in",
        value: "19",
        description: "5ft 7in"
      }
    },
    {
      id: "20",
      data: {
        label: "5ft 8in",
        value: "20",
        description: "5ft 8in"
      }
    },
    {
      id: "21",
      data: {
        label: "5ft 9in",
        value: "21",
        description: "5ft 9in"
      }
    },
    {
      id: "22",
      data: {
        label: "5ft 10in",
        value: "22",
        description: "5ft 10in"
      }
    },
    {
      id: "23",
      data: {
        label: "5ft 11in",
        value: "23",
        description: "5ft 11in"
      }
    },
    {
      id: "24",
      data: {
        label: "6ft",
        value: "24",
        description: "6ft"
      }
    },
    {
      id: "25",
      data: {
        label: "6ft 1in",
        value: "25",
        description: "6ft 1in"
      }
    },
    {
      id: "26",
      data: {
        label: "6ft 2in",
        value: "26",
        description: "6ft 2in"
      }
    },
    {
      id: "27",
      data: {
        label: "6ft 3in",
        value: "27",
        description: "6ft 3in"
      }
    },
    {
      id: "28",
      data: {
        label: "6ft 4in",
        value: "28",
        description: "6ft 4in"
      }
    },
    {
      id: "29",
      data: {
        label: "6ft 5in",
        value: "29",
        description: "6ft 5in"
      }
    },
    {
      id: "30",
      data: {
        label: "6ft 6in",
        value: "30",
        description: "6ft 6in"
      }
    },
    {
      id: "31",
      data: {
        label: "6ft 7in",
        value: "31",
        description: "6ft 7in"
      }
    },
    {
      id: "32",
      data: {
        label: "6ft 8in",
        value: "32",
        description: "6ft 8in"
      }
    },
    {
      id: "33",
      data: {
        label: "6ft 9in",
        value: "33",
        description: "6ft 9in"
      }
    },
    {
      id: "34",
      data: {
        label: "6ft 10in",
        value: "34",
        description: "6ft 10in"
      }
    },
    {
      id: "35",
      data: {
        label: "6ft 11in",
        value: "35",
        description: "6ft 11in"
      }
    },
    {
      id: "36",
      data: {
        label: "7ft",
        value: "36",
        description: "7ft"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.HEIGHT)
      .doc(item.id)
      .set(item.data);
  });
};
const addDisability = () => {
  const values = [
    {
      id: "normal",
      data: {
        label: "Normal",
        value: "normal",
        description: "Normal"
      }
    },
    {
      id: "physicallyChallenged",
      data: {
        label: "Physically Challenged",
        value: "physicallyChallenged",
        description: "Physically Challenged"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.DISABILITY)
      .doc(item.id)
      .set(item.data);
  });
};
const addFamilyStatus = () => {
  const values = [
    {
      id: "middle",
      data: {
        label: "Middle",
        value: "middle",
        description: "Middle"
      }
    },
    {
      id: "upperMiddle",
      data: {
        label: "Upper Middle",
        value: "upperMiddle",
        description: "Upper Middle"
      }
    },
    {
      id: "rich",
      data: {
        label: "Rich",
        value: "rich",
        description: "Rich"
      }
    },
    {
      id: "affluent",
      data: {
        label: "Affluent",
        value: "affluent",
        description: "Affluent"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.FAMILY_STATUS)
      .doc(item.id)
      .set(item.data);
  });
};
const addFamilyValue = () => {
  const values = [
    {
      id: "orthodox",
      data: {
        label: "Orthodox",
        value: "orthodox",
        description: "Orthodox"
      }
    },
    {
      id: "traditional",
      data: {
        label: "Traditional",
        value: "traditional",
        description: "Traditional"
      }
    },
    {
      id: "moderate",
      data: {
        label: "Moderate",
        value: "moderate",
        description: "Moderate"
      }
    },
    {
      id: "liberal",
      data: {
        label: "Liberal",
        value: "liberal",
        description: "Liberal"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.FAMILY_VALUE)
      .doc(item.id)
      .set(item.data);
  });
};
const addFamilyType = () => {
  const values = [
    {
      id: "nuclear",
      data: {
        label: "Nuclear",
        value: "nuclear",
        description: "Nuclear"
      }
    },
    {
      id: "joint",
      data: {
        label: "Joint",
        value: "joint",
        description: "Joint"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.FAMILY_TYPE)
      .doc(item.id)
      .set(item.data);
  });
};
const addHouseType = () => {
  const values = [
    {
      id: "rent",
      data: {
        label: "Rent",
        value: "rent",
        description: "Rent"
      }
    },
    {
      id: "own",
      data: {
        label: "Own",
        value: "own",
        description: "Own"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.HOUSE_TYPE)
      .doc(item.id)
      .set(item.data);
  });
};
const addMoonSign = () => {
  const values = [
    {
      id: "aries",
      data: {
        label: "Aries",
        value: "aries",
        description: "Aries"
      }
    },
    {
      id: "taurus",
      data: {
        label: "Taurus",
        value: "taurus",
        description: "Taurus"
      }
    },
    {
      id: "gemini",
      data: {
        label: "Gemini",
        value: "gemini",
        description: "Gemini"
      }
    },
    {
      id: "cancer",
      data: {
        label: "Cancer",
        value: "cancer",
        description: "Cancer"
      }
    },
    {
      id: "leo",
      data: {
        label: "Leo",
        value: "leo",
        description: "Leo"
      }
    },
    {
      id: "virgo",
      data: {
        label: "Virgo",
        value: "virgo",
        description: "Virgo"
      }
    },
    {
      id: "libra",
      data: {
        label: "Libra",
        value: "libra",
        description: "Libra"
      }
    },
    {
      id: "scorpio",
      data: {
        label: "Scorpio",
        value: "scorpio",
        description: "Scorpio"
      }
    },
    {
      id: "sagittarius",
      data: {
        label: "Sagittarius",
        value: "sagittarius",
        description: "Sagittarius"
      }
    },
    {
      id: "capricorn",
      data: {
        label: "Capricorn",
        value: "capricorn",
        description: "Capricorn"
      }
    },
    {
      id: "aquarius",
      data: {
        label: "Aquarius",
        value: "aquarius",
        description: "Aquarius"
      }
    },
    {
      id: "pisces",
      data: {
        label: "Pisces",
        value: "pisces",
        description: "Pisces"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.MOON_SIGN)
      .doc(item.id)
      .set(item.data);
  });
};
const addCreatedBy = () => {
  const values = [
    {
      id: "self",
      data: {
        label: "Self",
        value: "self",
        description: "self"
      }
    },
    {
      id: "parent",
      data: {
        label: "Parent/Guardian",
        value: "parent",
        description: "Parent/Guardian"
      }
    },
    {
      id: "sibling",
      data: {
        label: "Sibling",
        value: "sibling",
        description: "Sibling"
      }
    },
    {
      id: "friend",
      data: {
        label: "Friend",
        value: "friend",
        description: "Friend"
      }
    },
    {
      id: "other",
      data: {
        label: "Other",
        value: "other",
        description: "Other"
      }
    }
  ];
  forEach(values, item => {
    firestore
      .collection(Collection.CREATED_BY)
      .doc(item.id)
      .set(item.data);
  });
};
const data = {
  addMaritalStatus,
  addMotherTongue,
  addComplexion,
  addBodyType,
  addDiet,
  addHabitTypes,
  addJobType,
  addIncome,
  addEducation,
  addEmployedIn,
  addReligion,
  addCaste,
  addHeight,
  addDisability,
  addFamilyStatus,
  addFamilyValue,
  addFamilyType,
  addHouseType,
  addMoonSign,
  addCreatedBy
};
export default data;



// WEBPACK FOOTER //
// ./src/_data/index.js